module.exports = __webpack_public_path__ + "img/pocket bag height.4577616b.png";